import type { BaseComponentProps, ImageSources } from '../../types';
import type { StickerProps } from '../Sticker/Sticker';

export interface PictureProps extends BaseComponentProps {
  altText?: string;
  defaultSrc?: string;
  imgClassName?: string;
  imgSrcs?: ImageSources;
  height?: number;
  width?: number;
  fetchPriority?: 'high' | 'low' | 'auto';
  isDraggable?: boolean;
  /**
   * A known bug in Safari causes multiple images to be loaded when both src and srcset are set on
   * an <img> tag. This prop enables a workaround which sets src and srcset only after the image has
   * been rendered and attached to the real DOM on the client. This prevents the additional loads at
   * the cost of empty src and srcSet attributes on the initial SSR.
   *
   * - Bug: https://bug-190031-attachments.webkit.org/attachment.cgi?id=456958
   * - Workaround: https://github.com/facebook/react/issues/20682#issuecomment-1140181778
   */
  handleSafariSourceSets?: boolean;
}

export interface PictureWithStickersProps extends PictureProps {
  stickers?: StickerProps[];
}
